import Markdown from '../Markdown'
import { bodyText } from '../player/playerStyles'

const TextBlock = ({ block }) => <Markdown sx={bodyText}>{block.body}</Markdown>

export default TextBlock
